import React, { Component } from "react";
import { getValue } from "../utils/models";
import { Row, Col } from "antd";
import AutoInput from "../containers/AutoInput";
import MapForm from "../forms/MapForm";
import withValues from "../hocs/withValues";

class LocationForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showContent: false,
      customer: null,
      customerQuery: null
    };
  }

  componentWillMount() {
    setTimeout(() => {
      this.setState({ showContent: true });
    }, 300);
  }

  componentDidUpdate(prevProps) {
    if (this.props.values !== prevProps.values) {
      this.setState({
        customer: getValue(this.props.values, "customer")
      });
    }
  }

  render() {
    let filter = {
      or: [
        {
          verified: true,
          id: this.state.customer
        }
      ]
    };

    if (this.state.customerQuery) {
      filter.or = [
        ...filter.or,
        {
          active: true,
          verified: true,
          name: {
            contains: this.state.customerQuery
          }
        }
      ];
    }

    return (
      <div style={{ display: this.state.showContent ? "block" : "hidden" }}>
        <Row gutter={6}>
          <Col span={24}>
            <AutoInput
              value={getValue(this.props.values, "name")}
              form={this.props.form}
              model="location"
              attribute="name"
            />
          </Col>
          <Col span={24}>
            <div style={{ height: "400px", padding: "0 25px" }}>
              {this.state.showContent && (
                <MapForm
                  center={{
                    lat: getValue(this.props.values, "lat"),
                    lng: getValue(this.props.values, "lng")
                  }}
                  form={this.props.form}
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBzhd2gYGYfl0bdmCeLGrOjtwzcKcfYmF0&v=3.exp&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: "100%" }} />}
                  containerElement={
                    <div
                      style={{
                        height: 400,
                        borderRadius: 3,
                        overflow: "hidden"
                      }}
                    />
                  }
                  mapElement={<div style={{ height: "100%" }} />}
                />
              )}
            </div>
          </Col>
          <Col span={24}>
            <AutoInput
              value={getValue(this.props.values, "address")}
              form={this.props.form}
              model="location"
              attribute="address"
            />
          </Col>
          <Col span={24}>
            <AutoInput
              value={getValue(this.props.values, "customer")}
              form={this.props.form}
              model="location"
              attribute="customer"
              onSearch={value => {
                this.setState({ customerQuery: value });
              }}
              onChange={value => {
                this.setState({ customer: value });
              }}
              placeholder={"Busca un cliente"}
              filter={filter}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              value={getValue(this.props.values, "locality")}
              form={this.props.form}
              model="location"
              attribute="locality"
            />
          </Col>
          <Col span={12}>
            <AutoInput
              value={getValue(this.props.values, "suburb")}
              form={this.props.form}
              model="location"
              attribute="suburb"
            />
          </Col>
          <Col span={12}>
            <AutoInput
              value={getValue(this.props.values, "zipCode")}
              form={this.props.form}
              model="location"
              attribute="zipCode"
            />
          </Col>
          <Col span={12}>
            <AutoInput
              value={getValue(this.props.values, "municipality")}
              form={this.props.form}
              model="location"
              attribute="municipality"
            />
          </Col>
          <Col span={8}>
            <AutoInput
              value={getValue(this.props.values, "street")}
              form={this.props.form}
              model="location"
              attribute="street"
            />
          </Col>
          <Col span={8}>
            <AutoInput
              value={getValue(this.props.values, "exteriorNumber")}
              form={this.props.form}
              model="location"
              attribute="exteriorNumber"
            />
          </Col>
          <Col span={8}>
            <AutoInput
              value={getValue(this.props.values, "interiorNumber")}
              form={this.props.form}
              model="location"
              attribute="interiorNumber"
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              model={"location"}
              id={this.props.id}
              autoSave
              value={getValue(
                this.props.values,
                "customerTaxIdRegistrationNumber"
              )}
              attribute={"customerTaxIdRegistrationNumber"}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              model={"location"}
              id={this.props.id}
              autoSave
              value={getValue(this.props.values, "customerTaxResidence")}
              attribute={"customerTaxResidence"}
              required
              items={["MEX", "USA"]}
              type={"model"}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default withValues(LocationForm);



// WEBPACK FOOTER //
// ./src/forms/Location.js